import { t } from '@lingui/macro'

/**
 * The hospital's general contact details, used when an agenda item carries no contact of its own.
 * The strings are per tenant in the i18n catalogs, so each hospital shows its own.
 */
function hospitalContactFallback() {
  return {
    name: t({
      id: 'globals.azmm-contact.name',
      comment: 'General contact info name of AZMM',
      message: 'AZ Maria Middelares',
    }),
    phone: t({
      id: 'globals.azmm-contact.phone',
      comment: 'General contact info phone number of AZMM',
      message: '+32 9 246 46 46',
    }),
  }
}

type ContactSource = { name?: string; phone?: string } | undefined

/**
 * The contact an agenda item shows: the first name and the first phone its sources offer, each
 * on its own, and the hospital's general contact for whatever is left.
 */
function resolveAgendaContact(...sources: ContactSource[]): { name: string; phone: string } {
  const fallback = hospitalContactFallback()

  return {
    name: sources.find((source) => source?.name)?.name || fallback.name,
    phone: sources.find((source) => source?.phone)?.phone || fallback.phone,
  }
}

export { resolveAgendaContact }
